// extracted by mini-css-extract-plugin
export default {"image":"ReportTypeList_image__au0wf"};